import type { Placement } from '@popperjs/core'
import type { ReactNode } from 'react'
import ConfigurationTypeButton from '../ConfigurationTypeButton/ConfigurationTypeButton'
import PopOut from '../PopOut/PopOut'
import classes from './ConfigTypePopOut.module.scss'

export interface Props {
  children: ReactNode
  title: number
  placement?: Placement
  isPopOutAlign?: boolean
  hasFixWidth?: boolean
  label?: string
  configIcon: ReactNode
}

const ConfigTypePopOut = ({
  children,
  title,
  placement = 'bottom',
  isPopOutAlign = false,
  hasFixWidth = true,
  configIcon,
  label
}: Props) => {
  const triggerInfoButton = (ref: any, onClick: () => void, isOpen?: boolean) => (
    <ConfigurationTypeButton
      configIcon={configIcon}
      isStayFocus={isOpen}
      label={label}
      onClick={onClick}
      ref={ref}
      title={title}
    />
  )

  const widthClass = !hasFixWidth
    ? classes.noFixWidth
    : ''

  const getListPopOutClasses = () => [
    classes.ConfigTypePopOut,
    widthClass
  ].filter(classStyle => classStyle).join(' ')

  return (
    <PopOut
      isPopOutAlign={isPopOutAlign}
      placement={placement}
      trigger={triggerInfoButton}
    >
      <div className={getListPopOutClasses()}>
        {children}
      </div>
    </PopOut>
  )
}

export default ConfigTypePopOut
